// extracted by mini-css-extract-plugin
export default {"expandButton":"app-portainer-components-datatables-components-ExpandingCell-module__expand-button"};